import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { UtilitiesService } from '../services/utilities/utilities.service';
import { DataService } from '../services/data/data.service';

@Directive({
  selector: '[appIsPlanFFS]'
})
export class IsPlanFFSDirective implements OnInit {

  constructor(
    private dataService: DataService,
    private el: ElementRef,
    private renderer2: Renderer2
  ) { }


  ngOnInit(): void {
    const isPlanFFS = this.dataService.isPlanFFS();
    const isPlanFFSSelected = this.dataService.isPlanFFSSelected$.getValue()
    const label = (isPlanFFS && isPlanFFSSelected) ? 'Service fee' : 'Deductible';
    this.renderer2.setProperty(this.el.nativeElement, 'innerText', label);
  }

}
